module.exports = __webpack_public_path__ + "static/media/How to customize email link template for Invoice Email.3689dd39.png";